module.exports = true;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/_library.js
 ** module id = 135
 ** module chunks = 1
 **/